// extracted by mini-css-extract-plugin
export default {"cls1":"VeloErrorCard-Close_cls1__eOpW5","cls2":"VeloErrorCard-Close_cls2__pfB4F VeloErrorCard-Close_cls1__eOpW5"};